module.exports = "<div class=box> <div class=box-row> <div class=box-cell> <div class=\"box-inner padding-box\" ui-view id=view> </div> </div> </div> </div> ";


//////////////////
// WEBPACK FOOTER
// ./src/layout/content-fullscreen.html
// module id = 174
// module chunks = 0